import React from 'react';
import {
  Button,
  Checkbox,
  ExpoImage,
  Icon,
  ScreenContainer,
  TextInput,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import showAlertUtil from '../utils/showAlert';
import useWindowDimensions from '../utils/useWindowDimensions';

const ResetPasswordScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [checkboxValue, setCheckboxValue] = React.useState(false);
  const [confirmPasswordInput, setConfirmPasswordInput] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [isShowConfirmPassword, setIsShowConfirmPassword] =
    React.useState(false);
  const [isShowPassword, setIsShowPassword] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState('');
  const [textInputValue, setTextInputValue] = React.useState('');
  const leadFunlDefaultResetPasswordFinalPOST =
    LeadFunlDefaultApi.useResetPasswordFinalPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      hasTopSafeArea={true}
    >
      {/* Header */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
          dimensions.width
        )}
      >
        {/* Back */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        >
          <Touchable
            onPress={() => {
              try {
                navigation.goBack();
              } catch (err) {
                console.error(err);
              }
            }}
          >
            <Icon size={24} name={'AntDesign/arrowleft'} />
          </Touchable>
        </View>
        {/* Screen Heading */}
        <Text
          accessible={true}
          selectable={false}
          style={StyleSheet.applyWidth(
            {
              color: theme.colors.text.strong,
              fontFamily: 'Poppins_400Regular',
              fontSize: 15,
            },
            dimensions.width
          )}
        >
          {'  '}
        </Text>
        {/* Blank */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        />
      </View>
      {/* container */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
            flex: { minWidth: Breakpoints.Tablet, value: 1 },
            flexDirection: { minWidth: Breakpoints.Tablet, value: 'row' },
            justifyContent: { minWidth: Breakpoints.Tablet, value: 'center' },
          },
          dimensions.width
        )}
      >
        {/* Details View */}
        <>
          {!(dimensions.width >= Breakpoints.Tablet) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
                  flex: 1,
                  justifyContent: {
                    minWidth: Breakpoints.Tablet,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              <ExpoImage
                allowDownscaling={true}
                cachePolicy={'disk'}
                contentPosition={'center'}
                transitionDuration={300}
                transitionEffect={'cross-dissolve'}
                transitionTiming={'ease-in-out'}
                {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
                resizeMode={'contain'}
                source={imageSource(Images['_659caa814a5d2ddd2cdc17d8'])}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                    {
                      height: { minWidth: Breakpoints.Tablet, value: 300 },
                      width: { minWidth: Breakpoints.Tablet, value: '70%' },
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>
          )}
        </>
        <View
          style={StyleSheet.applyWidth(
            {
              flex: { minWidth: Breakpoints.Tablet, value: 1 },
              justifyContent: 'space-evenly',
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 20,
            },
            dimensions.width
          )}
        >
          {/* Heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: theme.colors.branding.primary,
                fontFamily: 'Poppins_700Bold',
                fontSize: 35,
                marginBottom: 10,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {'Reset your\nPassword'}
          </Text>
          {/* sub heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: palettes.App['Custom Color_9'],
                fontFamily: 'Poppins_400Regular',
                fontSize: 15,
                opacity: 0.7,
                paddingBottom: 10,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {'Please enter your new password'}
          </Text>

          <View
            style={StyleSheet.applyWidth(
              { justifyContent: 'center' },
              dimensions.width
            )}
          >
            {/* Password */}
            <TextInput
              autoCapitalize={'none'}
              autoCorrect={true}
              changeTextDelay={500}
              onChangeText={newPasswordValue => {
                try {
                  setNewPassword(newPasswordValue);
                } catch (err) {
                  console.error(err);
                }
              }}
              webShowOutline={true}
              editable={true}
              placeholder={'New Password'}
              placeholderTextColor={theme.colors.text.light}
              secureTextEntry={!isShowPassword}
              style={StyleSheet.applyWidth(
                {
                  backgroundColor: palettes.App['Custom Color_3'],
                  borderBottomWidth: 1,
                  borderColor: theme.colors.border.brand,
                  borderLeftWidth: 1,
                  borderRadius: 24,
                  borderRightWidth: 1,
                  borderTopWidth: 1,
                  fontFamily: 'Poppins_400Regular',
                  fontSize: 15,
                  height: 48,
                  marginTop: 20,
                  paddingBottom: 8,
                  paddingLeft: 20,
                  paddingRight: 20,
                  paddingTop: 8,
                },
                dimensions.width
              )}
              value={newPassword}
            />
            <Checkbox
              onPress={newCheckboxValue => {
                try {
                  setIsShowPassword(newCheckboxValue);
                } catch (err) {
                  console.error(err);
                }
              }}
              checkedIcon={'Ionicons/eye-off-sharp'}
              status={isShowPassword}
              style={StyleSheet.applyWidth(
                { position: 'absolute', right: 20, top: 32 },
                dimensions.width
              )}
              uncheckedIcon={'Ionicons/eye-sharp'}
            />
          </View>
          {/* View 2 */}
          <View>
            {/* Confirm Password */}
            <TextInput
              autoCapitalize={'none'}
              autoCorrect={true}
              changeTextDelay={500}
              onChangeText={newConfirmPasswordValue => {
                try {
                  setConfirmPasswordInput(newConfirmPasswordValue);
                } catch (err) {
                  console.error(err);
                }
              }}
              webShowOutline={true}
              editable={true}
              placeholder={'Confirm Password'}
              placeholderTextColor={theme.colors.text.light}
              secureTextEntry={!isShowConfirmPassword}
              style={StyleSheet.applyWidth(
                {
                  backgroundColor: palettes.App['Custom Color_3'],
                  borderBottomWidth: 1,
                  borderColor: theme.colors.border.brand,
                  borderLeftWidth: 1,
                  borderRadius: 24,
                  borderRightWidth: 1,
                  borderTopWidth: 1,
                  fontFamily: 'Poppins_400Regular',
                  fontSize: 15,
                  height: 48,
                  marginTop: 20,
                  paddingBottom: 8,
                  paddingLeft: 20,
                  paddingRight: 20,
                  paddingTop: 8,
                },
                dimensions.width
              )}
              value={confirmPasswordInput}
            />
            {/* Checkbox 2 */}
            <Checkbox
              onPress={newCheckbox2Value => {
                try {
                  setIsShowConfirmPassword(newCheckbox2Value);
                } catch (err) {
                  console.error(err);
                }
              }}
              checkedIcon={'Ionicons/eye-off-sharp'}
              status={isShowConfirmPassword}
              style={StyleSheet.applyWidth(
                { position: 'absolute', right: 20, top: 32 },
                dimensions.width
              )}
              uncheckedIcon={'Ionicons/eye-sharp'}
            />
          </View>
          {/* View 3 */}
          <View>
            {/* View 3 */}
            <View
              style={StyleSheet.applyWidth(
                { height: 28, marginTop: 6 },
                dimensions.width
              )}
            >
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    theme.typography.body1,
                    { color: palettes.Brand.Error, textAlign: 'center' }
                  ),
                  dimensions.width
                )}
              >
                {errorMessage}
              </Text>
            </View>
          </View>
          {/* Reset Password */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              const handler = async () => {
                try {
                  if (newPassword !== confirmPasswordInput) {
                    setErrorMessage("Password dosen't matched!");
                  }
                  if (newPassword !== confirmPasswordInput) {
                    return;
                  }
                  setIsLoading(true);
                  const api_Response = (
                    await leadFunlDefaultResetPasswordFinalPOST.mutateAsync({
                      confirm_password: confirmPasswordInput,
                      new_password: newPassword,
                    })
                  )?.json;
                  setIsLoading(false);
                  if (api_Response?.message) {
                    setErrorMessage(api_Response?.message);
                  } else {
                    setGlobalVariableValue({
                      key: 'TEMP_AUTH_TOKEN',
                      value: '',
                    });
                    navigation.navigate('LoginScreen');

                    showAlertUtil({
                      title: 'Success!',
                      message: 'Password Updated Successfully.',
                      buttonText: 'Ok',
                    });
                  }
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            loading={isLoading}
            style={StyleSheet.applyWidth(
              {
                backgroundColor: theme.colors.branding.primary,
                borderRadius: 24,
                color: palettes.App['Custom Color_4'],
                fontFamily: 'Poppins_500Medium',
                fontSize: 17,
                height: 46,
                marginTop: 40,
                textAlign: 'center',
              },
              dimensions.width
            )}
            title={'Reset Password'}
          />
        </View>
      </View>
    </ScreenContainer>
  );
};

export default withTheme(ResetPasswordScreen);
